import React from 'react';
import ClaimSelectionFromDateField from './ClaimSelectionFromDateField';
import { Col, Form, Row, Table, Button } from 'react-bootstrap';
import { Button as SubmittButton } from '@rd-web-markets/shared/dist/util/buttons';
import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date';
const ClaimsSelectionFieldFullDate = _ref => {
  let {
    toggleInclude,
    claims,
    includeSingleClaim,
    loading,
    setFromDate,
    setClaims
  } = _ref;
  const deselectAllClaims = () => {
    const updatedClaims = claims.map(claim => ({
      ...claim,
      include: false
    }));
    setClaims(updatedClaims);
  };
  const hasIncludedClaims = claims.some(claim => claim.include === true);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("hr", null), !includeSingleClaim && hasIncludedClaims && /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 6,
      offset: 3
    },
    className: "text-end"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "sm",
    onClick: deselectAllClaims
  }, "Deselect All"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 6,
      offset: 3
    }
  }, /*#__PURE__*/React.createElement(Table, {
    className: "table table-hover"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    className: "text-primary app-fs-table-header"
  }, /*#__PURE__*/React.createElement("th", {
    className: "font-weight-normal"
  }, "Name"), /*#__PURE__*/React.createElement("th", {
    className: "font-weight-normal"
  }, "From Date"), /*#__PURE__*/React.createElement("th", {
    className: "font-weight-normal"
  }, "To Date"), /*#__PURE__*/React.createElement("th", {
    className: "font-weight-normal"
  }, "Include?"))), /*#__PURE__*/React.createElement("tbody", null, claims.map((claim, index) => /*#__PURE__*/React.createElement("tr", {
    key: index
  }, /*#__PURE__*/React.createElement("td", null, claim.kimble_name), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ClaimSelectionFromDateField, {
    claim: claim,
    setFromDate: setFromDate
  })), /*#__PURE__*/React.createElement("td", null, createTimezonedDate(claim.to_date, true).toCustomLocaleDateString()), includeSingleClaim ? /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(SubmittButton, {
    disabled: !claim.from_date,
    variant: "info",
    size: "sm",
    loading: loading,
    onClick: () => toggleInclude(claim)
  }, "Select ", /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_right"))) : /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Check, {
    className: "text-start",
    type: "checkbox",
    name: "include",
    disabled: !claim.from_date,
    checked: claim.include,
    value: claim.include,
    onChange: e => toggleInclude(e, index)
  })))))))));
};
export default ClaimsSelectionFieldFullDate;